import { Button, Input } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { AceptacionLegal } from "../AceptacionLegal";

interface IProps {
  nombrepropuesta: string;
  cambiarnombrepropuesta: (e: any) => void;
  /** Se guarda al salir del campo, no mientras se escribe. */
  alSalirDelNombre: () => void;
  url: string;
  cambiarurl: (e: any) => void;
  agregarurl: () => void;
  urls: any[];
  eliminarurl: (indice: number) => void;
  /** Las politicas y los terminos, que sin aceptar no dejan inscribir. */
  aceptaCondiciones: boolean;
  alAceptarCondiciones: (aceptado: boolean) => void;
}

/** Tercer paso: el nombre del proyecto y los enlaces que lo acompañan. */
export const Paso3Propuesta = ({
  nombrepropuesta,
  cambiarnombrepropuesta,
  alSalirDelNombre,
  url,
  cambiarurl,
  agregarurl,
  urls,
  eliminarurl,
  aceptaCondiciones,
  alAceptarCondiciones,
}: IProps) => (
  // Este paso tiene poco contenido: suelto en el ancho de la pagina quedaba
  // todo pegado al borde izquierdo. Va en un bloque centrado.
  <div className="container-fluid2">
    <div className="row justify-content-center mt-4">
      <div className="col-12 col-md-10 col-lg-8">
        <div className="mb-3">
          <label
            htmlFor="nombre-propuesta"
            className="font-family-Montserrat-SemiBold font-size-14px mb-2 d-block"
          >
            Nombre del proyecto <span style={{ color: "red" }}>*</span>
          </label>
          <Input
            id="nombre-propuesta"
            value={nombrepropuesta}
            onChange={cambiarnombrepropuesta}
            onBlur={alSalirDelNombre}
            placeholder="Escribe el nombre de tu proyecto"
          />
        </div>

        <div className="mb-2">
          <label
            htmlFor="url-propuesta"
            className="font-family-Montserrat-SemiBold font-size-14px mb-2 d-block"
          >
            Enlaces
          </label>
          <div className="d-flex" style={{ gap: 8 }}>
            <Input
              id="url-propuesta"
              value={url}
              onChange={cambiarurl}
              placeholder="https://..."
            />
            <Button className="button-azul-radius" onClick={agregarurl}>
              Agregar
            </Button>
          </div>
          <span className="font-family-Montserrat-Regular font-size-10px font-color-7E7E7E">
            El enlace debe empezar por https://
          </span>
        </div>

        <div>
          {urls.length === 0 ? (
            <span className="font-family-Montserrat-Regular font-size-12px font-color-7E7E7E">
              Todavía no has agregado ningún enlace.
            </span>
          ) : (
            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
              {urls.map((enlace: any, indice: number) => (
                <li
                  key={enlace.url}
                  className="d-flex align-items-center justify-content-between font-family-Montserrat-Regular font-size-12px"
                  style={{ borderBottom: "1px solid #E8E8E8", padding: "6px 0" }}
                >
                  <span style={{ wordBreak: "break-all" }}>{enlace.url}</span>
                  <Button
                    type="link"
                    aria-label={`Eliminar ${enlace.url}`}
                    onClick={() => eliminarurl(indice)}
                  >
                    <DeleteOutlined className="font-color-DB2828" />
                  </Button>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/*
          Lo ultimo del ultimo paso, pegado al boton de inscribir: es lo que
          se declara al enviar, no un dato mas del formulario.
        */}
        <div className="mt-4 pt-3" style={{ borderTop: "1px solid #E8E8E8" }}>
          <AceptacionLegal
            aceptado={aceptaCondiciones}
            alCambiar={alAceptarCondiciones}
          />
        </div>
      </div>
    </div>
  </div>
);
